<cl-waves-background wizard-bg bg-position-bottom>
  <ion-content>
    <ion-header>
      <cl-header-nav-buttons
        color="primary"
        (closeClick)="done()"
        [backButton]="false"
        [title]="'wizards.rain_exercise' | translate"
        class="page-header"
      >
      </cl-header-nav-buttons>
    </ion-header>

    <div class="exercise-wrapper lateral-padding">
      <div class="play-wrapper">
        <cl-play-exercise
          [showTitle]="false"
          [exercise]="rainExercise$ | async"
          [autoplay]="false">
        </cl-play-exercise>
      </div>
    </div>
  </ion-content>

  <ion-footer>
    <div class="lateral-padding">
      <ion-row>
        <ion-col size="6" offset="3" class="ion-text-center">
          <cl-next-button
            label="{{'common.done' | translate}}"
            [canClick]="true"
            (action)="done()">
          </cl-next-button>
        </ion-col>
      </ion-row>
    </div>
  </ion-footer>
</cl-waves-background>
